import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpEvent, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ClientStore } from './client.store';
import { getId, isset } from '@cawita/core-front';

@Injectable()
export class ClientIdInterceptor implements HttpInterceptor {
    constructor(private client: ClientStore) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const { activeClient } = this.client.getValue();
        const isClientRequest = req.url.includes(':clientId');
        if (!isset(activeClient) || !isClientRequest) return next.handle(req);
        return next.handle(req.clone({ url: req.url.replace(':clientId', getId(activeClient)) }));
    }
}